import { render, staticRenderFns } from "./ZeroxaIndex.vue?vue&type=template&id=ca33ccd8&"
import script from "./ZeroxaIndex.vue?vue&type=script&lang=js&"
export * from "./ZeroxaIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports